export const QA_NAME_DOC_FLOW_EPOST_VALIDATION_PREVIEW_MODAL =
  'docFlowEpostValidationPreviewModal'

export const DocFlowEpostValidationPreviewFieldName = {
  Errors: 'errors',
  PreviewImage: 'preview_image',
}

export const DocFlowEpostValidationPreviewErrorFieldName = {
  Code: 'code',
  Text: 'text',
}

export const DOC_FLOW_EPOST_VALIDATION_PREVIEW_TITLE_KEY =
  'DocFlow.EpostValidationPreviewModalTitleKey'

export const DOC_FLOW_EPOST_VALIDATION_PREVIEW_FILE_NAME_SEPARATOR = ' - '
